import styled from 'styled-components';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { SpacingStack } from '@components/SpacingStack';

export const ColumnWrapper = styled.div<{ left: number }>`
  position: absolute;
  z-index: 3;
  top: 0px;
  left: ${({ left }) => left}px;
  opacity: 0.5;
`;

export const Wrapper = styled(Box)`
  position: relative;
  width: 100%;
  height: 926px;
`;

export const TitleWrapper = styled(CloudImage)`
  width: 100%;
  height: auto;
`;

export const ImgWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  transition: transform 0.2s ease-in-out;
`;

export const GuestWrap = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    position: relative;
    overflow-y: hidden;
  }
`;

export const HeadTitleWrapper = styled(Box)`
  max-width: 1020px;
  margin: 0 auto;
  margin-bottom: ${themeSpace(12)};
  ${themeMediaQuery('below_sm')} {
    max-width: 300px;
    margin-bottom: ${themeSpace(8)};
  }
`;

export const GuestImageWrapper = styled(CloudImage)`
  padding-right: ${themeSpace(7)};
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    width: 260%;
    margin-left: -8%;
  }
`;

export const StyledGuestDesktopImageWrapper = styled(CloudImage)`
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledGuestMobileImageWrapper = styled(CloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    display: block;
  }
`;

export const StyledGuestImageContainer = styled(Box)`
  height: 100%;
  width: 100%;
`;

export const GuestMainTextContainer = styled(Text)`
  max-width: 1020px;
  ${themeMediaQuery('below_sm')} {
    width: 320px;
  }
`;

export const StyledText = styled(Text)`
  max-width: 460px;
  ${themeMediaQuery('xl')} {
    max-width: 630px;
  }
`;

export const StyledSpacingStack = styled(SpacingStack)`
  align-items: center;
`;
